import React from 'react';
import SectionIcon from './SectionIcon';

export default function PublicSettingsSection({ values, setFieldValue }) {
  return (
    <div className="px-4 py-8">
      <SectionIcon title="公開設定">
        <span className="material-symbols-outlined text-primary text-xl">visibility</span>
      </SectionIcon>

      <div className="space-y-4">
        <div className="flex items-center justify-between py-4 border-b border-slate-50">
          <div>
            <p className="text-sm font-bold">公開ステータス</p>
            <p className="text-[10px] text-slate-500 mt-1">メニューを公開して予約を受け付けます</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={values.publicStatus}
              onChange={(e) => setFieldValue('publicStatus', e.target.checked)}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-slate-200 rounded-full peer peer-checked:bg-blue-btn-primary transition-colors"></div>
            <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-transform peer-checked:translate-x-5 shadow-sm"></div>
          </label>
        </div>

        {false && ( // 非表示(2026-04-08)
          <div className="flex items-center justify-between py-4">
            <div>
              <p className="text-sm font-bold">予約サイトへの掲載</p>
              <p className="text-[10px] text-slate-500 mt-1">外部予約ページにこのメニューを表示します</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={values.showOnBookingSite}
                onChange={(e) => setFieldValue('showOnBookingSite', e.target.checked)}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-slate-200 rounded-full peer peer-checked:bg-blue-btn-primary transition-colors"></div>
              <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-transform peer-checked:translate-x-5 shadow-sm"></div>
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
